import React, { useCallback, useEffect, useMemo, useState } from 'react';
import painelApi from '../../services/painelApi';

// Painel de Clientes → Operando: quem está com o sistema em uso e já vendeu hoje.
const ATUALIZA_MS = 60000;
const ORDEM = { operando: 0, vendeu: 1, online: 2, parado: 3, sem_dados: 4, fora_do_ar: 5 };
const ROTULO = {
  operando: { txt: '🟢 Operando', cor: '#166534' },
  vendeu: { txt: '🔵 Vendeu hoje, sem ninguém agora', cor: '#1e40af' },
  online: { txt: '🟡 Online, sem venda hoje', cor: '#92400e' },
  parado: { txt: '⚪ Sem movimento hoje', cor: '#64748b' },
  sem_dados: { txt: 'Sem dados (site ainda não atualizado)', cor: '#64748b' },
  fora_do_ar: { txt: '🔴 Fora do ar', cor: '#b91c1c' },
};

export function classificar(s) {
  if (s.situacao !== 'ok') return s.situacao;
  const online = (s.online || []).length > 0;
  if (s.vendas_hoje > 0) return online ? 'operando' : 'vendeu';
  return online ? 'online' : 'parado';
}

const hora = v => (v ? new Date(v).toLocaleTimeString('pt-BR', { timeZone: 'America/Sao_Paulo', hour: '2-digit', minute: '2-digit' }) : '—');
const th = { textAlign: 'left', padding: '6px 8px', background: '#f1f5f9', fontSize: 12 };
const td = { padding: '6px 8px', fontSize: 13, borderBottom: '1px solid #e5e7eb', verticalAlign: 'top' };

export default function ClientesOperando() {
  const [sites, setSites] = useState(null);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [em, setEm] = useState(null);

  const carregar = useCallback(() => {
    setCarregando(true);
    painelApi.get('/painel-clientes/atividade')
      .then(r => { setSites(r.data.sites); setErro(''); setEm(new Date()); })
      .catch(e => setErro(e.response?.data?.erro || 'Não foi possível consultar os clientes.'))
      .finally(() => setCarregando(false));
  }, []);
  useEffect(() => {
    carregar();
    const t = setInterval(carregar, ATUALIZA_MS);
    return () => clearInterval(t);
  }, [carregar]);

  const linhas = useMemo(() => (sites || [])
    .map(s => ({ ...s, estado: classificar(s) }))
    .sort((a, b) => ORDEM[a.estado] - ORDEM[b.estado] || (b.vendas_hoje || 0) - (a.vendas_hoje || 0) || a.nome.localeCompare(b.nome)), [sites]);

  if (erro && !sites) return <div style={{ padding: 16, color: '#b91c1c' }}>{erro}</div>;
  if (!sites) return <div style={{ padding: 16 }}>Consultando os clientes…</div>;

  const qtd = e => linhas.filter(l => l.estado === e).length;
  const minutos = linhas.find(l => l.minutos_online)?.minutos_online;

  return (
    <div style={{ padding: 16 }}>
      <div style={{ display: 'flex', gap: 16, alignItems: 'center', marginBottom: 6, flexWrap: 'wrap', fontSize: 13 }}>
        <strong style={{ fontSize: 15, color: '#166534' }}>{qtd('operando')} operando agora</strong>
        <span>{qtd('vendeu')} venderam e estão sem ninguém agora</span>
        <span>{qtd('online')} online sem venda</span>
        <span>{qtd('parado')} sem movimento</span>
        {qtd('fora_do_ar') > 0 && <strong style={{ color: '#b91c1c' }}>{qtd('fora_do_ar')} fora do ar</strong>}
        <button type="button" onClick={carregar} disabled={carregando} style={{ padding: '4px 12px', cursor: 'pointer' }}>
          {carregando ? 'Atualizando…' : '↻ Atualizar'}
        </button>
      </div>
      <p style={{ fontSize: 12, color: '#64748b', margin: '0 0 10px' }}>
        Online = usou o sistema nos últimos {minutos || 15} minutos. Atualiza sozinho a cada minuto{em ? `; última consulta às ${em.toLocaleTimeString('pt-BR')}` : ''}.
      </p>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr><th style={th}>Cliente</th><th style={th}>Situação</th><th style={th}>Quem está online</th><th style={th}>Vendas hoje</th><th style={th}>Última venda</th><th style={th}>Caixas abertos</th></tr></thead>
          <tbody>
            {linhas.map(l => (
              <tr key={l.chave}>
                <td style={{ ...td, fontWeight: 600 }}>{l.nome}</td>
                <td style={{ ...td, color: ROTULO[l.estado].cor, fontWeight: 600 }}>{ROTULO[l.estado].txt}</td>
                <td style={td}>{(l.online || []).join(', ') || '—'}</td>
                <td style={td}>{l.situacao === 'ok' ? l.vendas_hoje : '—'}</td>
                <td style={td}>{hora(l.ultima_venda)}</td>
                <td style={td}>{l.situacao === 'ok' ? l.caixas_abertos : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
